import { Component, inject } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { DOCUMENT, JsonPipe } from '@angular/common';
import { LogoutButtonComponent } from '../../components/logout-button/logout-button.component';
import { AuthStore } from '../../store/auth.store';

@Component({
  imports: [LogoutButtonComponent, JsonPipe],
  selector: 'auth-callback',
  templateUrl: 'callback.page.html',
  providers: [AuthStore]
})

export class CallbackPageComponent {
  private authService = inject(AuthService)
  private authStore = inject(AuthStore);
  private doc = inject(DOCUMENT);

  public userName = this.authStore.userName
  public userNickname = this.authStore.userNickname
  public userRoles = this.authStore.roles
  public userTenants = this.authStore.tenants
  public authUser = this.authStore.user
  public authStatus = this.authStore.isAuthenticated
  public isAuthLoading = this.authStore.isLoading

  handleLogout(): void {
    this.authService.logout(this.doc);
  }

}
